module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/euro-7fc4b4d72f4269cb57770d3182d66302.svg";